/* @flow */
'use strict';

import Draggable from './Draggable';

export default Draggable;
